<template>
  <div class="modal_compare_configs">
    <div class="header">
      <h4 class="title">
        {{ translate('config.compare_configs') }}
      </h4>
    </div>

    <div class="content">
      <div class="left">
        <div class="select_version">
          <label> {{ translate('config.old_ver') }} </label>
          <tree-select
              v-model="old_config.ver"
              :options="list_config_ver"
              :placeholder="translate('config.ver')"
              :clearable="false"
          />
        </div>
      </div>

      <div class="right">
        <div class="select_version">
          <label> {{ translate('config.new_ver') }} </label>
          <tree-select
              v-model="new_config.ver"
              :options="list_config_ver"
              :placeholder="translate('config.ver')"
              :clearable="false"
          />
        </div>
      </div>
    </div>

    <div class="result_wrap">

      <div class="legend">
        <span class="add">
          {{ translate('config.legend.add') }}
        </span>
        <span class="del">
          {{ translate('config.legend.del') }}
        </span>
        <span class="mod">
          {{ translate('config.legend.mod') }}
        </span>
      </div>

      <div class="result">
        <CodeDiff
            :old-string="old_config.config"
            :new-string="new_config.config"
        />
      </div>

    </div>

    <div class="text-center">
      <span
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="compare"
      >
        {{ translate('config.compare_configs') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>

import CodeDiff from "vue-code-diff";

export default {
  name: "CompareConfigs",
  props: [
    "dev_id",
    "list_config_ver",
    "old_version",
    "new_version"
  ],
  components: {
    CodeDiff
  },
  data () {
    return {
      old_config: {
        ver: null,
        config: ""
      },
      new_config: {
        ver: null,
        config: ""
      },
      result_compare: {},
    }
  },

  created() {
    this.old_config.ver = this.old_version ? this.old_version : this.list_config_ver[1].id
    this.new_config.ver = this.new_version ? this.new_version : this.list_config_ver[0].id
    this.compare()
  },

  // computed:{
  //   config_history(){
  //     return this.config_profile.table_data.map((arr) =>{
  //       return {id: arr[arr.length -1], label: arr[arr.length -1]}
  //     })
  //   }
  // },

  methods: {
    cancel () {
      this.$emit('close')
    },
    selected_block(block){
      this.block = block
    },
    compare(){
      let params = {
        config_old_version: this.old_config.ver,
        config_new_version: this.new_config.ver
      }
      this.$http.v1.compareConfigs(this.dev_id, params, (response) => {
        this.old_config.config = response.data.old_version?.main
        this.new_config.config = response.data.new_version?.main
        this.result_compare = response.data.different
      })

    }
  }
}

</script>

<style lang='scss'>
  .modal_compare_configs{
    padding: 10px;
    .header{
      text-align: center;
      .title{
        margin: 0 0 10px 0;
      }
    }
    .content{
      display: flex;
      .left, .right{
        width: 50%;
        .select_version{

        }
        .configuration{
          height: 200px;
          width: 100%;
          outline: none;
          resize: none;
          &::-webkit-scrollbar{
            width: 10px;
            cursor: pointer;
          }
        }
      }
      .left{
        padding: 0 5px 5px 0;
      }
      .right{
        padding: 0 0 5px 5px;
      }
    }
    .result{
      height: 400px;
      overflow: auto;
      &::-webkit-scrollbar{
        width: 10px;
      }
      &_wrap{
        .legend{
          display: flex;
          justify-content: space-around;
          margin-bottom: 10px;
          .add, .del, .mod{
            position: relative;
            font-size: 13px;
            line-height: 100%;
            &:before{
              position: absolute;
              left: -15px;
              width: 13px;
              height: 13px;
              content: "";
            }
          }
          .add {
            &:before{
              background-color: #dfd;
            }
          }
          .del{
            &:before{
              background-color: #ffb6ba;
            }
          }
          .mod{
            &:before{
              background-color: #fdf2d0;
            }
          }
        }
      }
    }
  }
</style>
